var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { PaperPlaneRightIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
export function ChatInput(_a) {
    var { onSend, className, disabled } = _a, props = __rest(_a, ["onSend", "className", "disabled"]);
    const inputRef = useRef(null);
    const [message, setMessage] = useState('');
    const handleSubmit = (e) => {
        var _a;
        e.preventDefault();
        (_a = props.onSubmit) === null || _a === void 0 ? void 0 : _a.call(props, e);
        onSend === null || onSend === void 0 ? void 0 : onSend(message);
        setMessage('');
    };
    const isDisabled = disabled || message.trim().length === 0;
    useEffect(() => {
        var _a;
        if (disabled) {
            return;
        }
        // when not disabled refocus on input
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [disabled]);
    return (_jsxs("form", Object.assign({}, props, { onSubmit: handleSubmit, className: cn('flex items-center gap-2 rounded-md pl-1 text-sm', className), children: [_jsx("input", { autoFocus: true, ref: inputRef, type: "text", value: message, disabled: disabled, placeholder: "Type something...", onChange: (e) => setMessage(e.target.value), className: "h-9 shrink-1 grow-1 pl-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50" }), _jsx(Button, { size: "icon", type: "submit", variant: isDisabled ? 'secondary' : 'primary', disabled: isDisabled, children: _jsx(PaperPlaneRightIcon, { weight: "bold" }) })] })));
}
